import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Role, UserRole } from '../models/models.lib';
import { SettingsService } from '../settings/settings.service';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';

export abstract class CasiCasiRoleService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch()
      .subscribe((x) => {
        console.log('query: x: ', x);
        return super.next(x);
      });
  }

  public queryUserRoles(userId: number): void {
    this.fetchUserRoles(userId)
      .subscribe((x) => {
        console.log('queryUserRoles: x: ', x);
        return super.next(x);
      })
  }

  protected fetch(): Observable<Role[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${this.settings.apiUrl}/findroles`))
      .pipe(
        map((response: any, i) => <Role[]>response),
        map(r => r.map(x => Role.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }

  protected fetchUserRoles(id: number): Observable<UserRole[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${this.settings.apiUrl}/findanyuserroles/${id}`))
      .pipe(
        map((response: any, i) => <UserRole[]>response),
        map(r => r.map(x => UserRole.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }

}

@Injectable({
  providedIn: 'root'
})
export class CasiRolesService extends CasiCasiRoleService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService
  ) {
    super(http, settingService);
  }

  getUserRoles(userId: number): Promise<UserRole[]> {
    return new Promise((resolve, reject) => {
      return this.fetchUserRoles(userId)
        .subscribe({
          next: resData => resolve(resData),
          error: err => reject(err)
        });
    });
  }

}
